export const axis = ['x', 'y'];
export const dims = ['left', 'width', 'right', 'top', 'height', 'bottom'];
export const start = { x: 'left', y: 'bottom' };
export const size = { x: 'width', y: 'height' };
export const end = { x: 'right', y: 'top' };
export const axisOp = { x: 'y', y: 'x' };
export const axisOpIndex = { x: 1, y: 0 };
export const startOp = { y: 'left', x: 'bottom' };
export const sizeOp = { y: 'width', x: 'height' };
export const endOp = { y: 'right', x: 'top' };
export function fromPercent(value, base) {
  if (!(value + '').endsWith('%')) {
    return Number(value);
  }

  return (Number(value.replace('%', '')) * base) / 100;
}

export function getAbsoluteShape(shape, parentSize) {
  const res = _.pick(shape, dims);
  if (res.left !== undefined) {
    res.left = fromPercent(res.left, parentSize.width);
    if (res.width !== undefined) {
      res.width = fromPercent(res.width, parentSize.width);
      res.right = parentSize.width - res.left - res.width;
    } else if (res.right !== undefined) {
      res.right = fromPercent(res.right, parentSize.width);
      res.width = parentSize.width - res.left - res.right;
    }
  } else if (res.right !== undefined) {
    res.right = fromPercent(res.right, parentSize.width);
    if (res.width !== undefined) {
      res.width = fromPercent(res.width, parentSize.width);
      res.left = parentSize.width - res.right - res.width;
    }
  }

  if (res.top !== undefined) {
    res.top = fromPercent(res.top, parentSize.height);
    if (res.height !== undefined) {
      res.height = fromPercent(res.height, parentSize.height);
      res.bottom = parentSize.height - res.top - res.height;
    } else if (res.bottom !== undefined) {
      res.bottom = fromPercent(res.bottom, parentSize.height);
      res.height = parentSize.height - res.top - res.bottom;
    }
  } else if (res.bottom !== undefined) {
    res.bottom = fromPercent(res.bottom, parentSize.height);
    if (res.height !== undefined) {
      res.height = fromPercent(res.height, parentSize.height);
      res.top = parentSize.height - res.bottom - res.height;
    }
  }

  return res;
}

export function normalizeShape(shape) {
  dims.forEach((d) => {
    if (shape[d] == 'auto') {
      delete shape[d];
    }
  });
  if (shape.width !== undefined) {
    if (shape.left !== undefined && shape.right !== undefined) {
      delete shape.right;
    }
  }

  if (shape.height !== undefined) {
    if (shape.top !== undefined && shape.bottom !== undefined) {
      delete shape.bottom;
    }
  }

  return shape;
}